import { useRef } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { logger } from '@gem/modules/logger';
import { PopupStore } from '@gem/popups';
import { replaceHtmlTagsToSpecialSymbols } from '@gem/utils';

import Tasks from 'APP/Tasks';
import {
  IShareCardPopupParams,
  ShareCardPopup,
} from 'APP/main/PopupManager/Popups/ShareCardPopup/ShareCardPopup';
import { greetingCardAnalytics } from 'APP/packages/analytics/analytics';
import { IShareSelection } from 'APP/types/share';
import Entities from 'STORE';
import { ShareCardButtonPayload } from 'STORE/Messages/Message/Payload/ButtonsPayload/ShareCardButtonPayload';
import { ImagePayload } from 'STORE/Messages/Message/Payload/ImagePayload/ImagePayload';

interface IShareCardCommandButtonPresenter {
  onClick(): void;
}

export const useShareCardCommandButtonPresenter = (
  buttonPayload: ShareCardButtonPayload
): IShareCardCommandButtonPresenter => {
  const { t } = useTranslation();
  const popupRef = useRef<PopupStore<IShareCardPopupParams>>();

  // TODO: move this logic inside ShareCardPopup component
  const onSubmit = async (selection: IShareSelection[]): Promise<void> => {
    if (!buttonPayload.imageUrl) {
      return;
    }

    try {
      const targetGroupIds = await Tasks.forward.getTargetGroupIds(selection);

      for (let i = 0; i < targetGroupIds.length; i++) {
        await Tasks.messaging.createNewMessages(targetGroupIds[i], [
          {
            payload: new ImagePayload({
              comment: replaceHtmlTagsToSpecialSymbols(buttonPayload.caption),
              url: buttonPayload.imageUrl,
            }),
          },
        ]);

        greetingCardAnalytics.trackCardSent();
      }

      if (targetGroupIds.length === 1) {
        if (Entities.GroupsStore.activeGroupId !== targetGroupIds[0]) {
          const targetGroup = Entities.GroupsStore.getGroupById(targetGroupIds[0]);
          if (targetGroup) {
            targetGroup.messagesStore.setSavePosition({ isBottom: true });
          }
          await Tasks.group.setActiveGroup({ groupId: targetGroupIds[0] });
        }
      }
      popupRef.current?.close();
    } catch (err: any) {
      logger.get('ShareCardCommandButton').error('createNewMessages', err);
      Entities.toast.show(t('something_went_wrong'));
    }
  };

  const onClick = (): void => {
    popupRef.current = Tasks.app.openPopup(ShareCardPopup, {
      params: { onSubmit, cardDeepLink: buttonPayload.cardDeepLink },
    });
  };

  return { onClick };
};
